import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';

export const stepHasOtherStandardBenefits = (
  step: CircuitDayFormData['steps'][number],
): boolean =>
  Boolean(
    step.transport?.standardBenefit ||
    step.activities?.standardBenefit ||
    step.meals?.standardBenefit,
  );
